import ToggleSwitch from "@/components/ToggleSwitch.jsx";
import React, {useEffect, useState} from "react";
import MileageSlider from "@/components/MileageSlider.jsx";
import {DangerButton, SecondaryButton} from "@/components/Buttons.jsx";
import {FaPlus, FaTrash, FaCrown} from "react-icons/fa6";
import {useSelector} from "react-redux";

const getInitialBreakpoints = (sections) => {
  return sections
    ?.map((section) => section.end)
    ?.filter((end) => end !== Math.max(...sections.map((section) => section.end)));
};
const DeliveryFee = ({ settings, setSettings, deliveryMethod, maxDeliveryDistance }) => {
  const [feeMode, setFeeMode] = useState(settings.type || "pass-through");
  const { user, selectedLocation } = useSelector((state) => state.app);
  const [mileageBreakpoint, setMileageBreakpoint] = useState(
    getInitialBreakpoints(settings.settings) || [3]
  );

  const [sections, setSections] = useState(settings.settings || []);
  useEffect(() => {
    setSettings({ ...settings, type: feeMode });
  }, [feeMode]);
  useEffect(() => {
    setSettings({ ...settings, settings: sections });
  }, [sections]);

  useEffect(() => {
    if (mileageBreakpoint && mileageBreakpoint.length > 0) {
      const sortedBreakpoints = [...mileageBreakpoint].sort((a, b) => a - b);
      const newSections = [];
      let start = 0;

      sortedBreakpoints.forEach((breakpoint, index) => {
        newSections.push({
          start,
          end: breakpoint,
          fees: sections[index]?.fees || [{ fee: 0, min: 0 }],
        });
        start = breakpoint;
      });

      newSections.push({
        start,
        end: maxDeliveryDistance,
        fees: sections[sections.length - 1]?.fees || [{ fee: 0, min: 0 }],
      });

      setSections(newSections);
    } else {
      setSections([
        {
          start: 0,
          end: maxDeliveryDistance,
          fees: sections[0]?.fees || [{ fee: 0, min: 0 }],
        },
      ]);
    }
  }, [mileageBreakpoint, maxDeliveryDistance]);

  const handleFeeChange = (sectionIndex, feeIndex, value, field) => {
    value = parseFloat(value);
    setSections((prevSections) => {
      const newSections = [...prevSections];
      newSections[sectionIndex].fees = newSections[sectionIndex].fees.map(
        (fee, index) => (index === feeIndex ? { ...fee, [field]: value } : fee)
      );
      return newSections;
    });
  };

  const addFee = (sectionIndex) => {
    setSections((prevSections) => {
      const newSections = [...prevSections];
      const lastFee = newSections[sectionIndex].fees.slice(-1)[0];
      newSections[sectionIndex].fees.push({ fee: 0, min: lastFee.min + 50 });
      return newSections;
    });
  };

  return (
    <div className="sm:flex sm:items-start space-y-4 sm:space-y-0 sm:space-x-4 mt-5 flex-col gap-2">
      <div className="flex flex-col gap-2">
        {user.type === "saucey_admin" && deliveryMethod === "dsp" && (
          <ToggleSwitch
            onLabel={
              <div>
                <div className="flex gap-1 items-center">
                  Saucey Paid <FaCrown />
                </div>
                <div className="text-sm">
                  (Admin option: Saucey is paying for delivery)
                </div>
              </div>
            }
            offLabel={
              <div>
                <div className="flex gap-1 items-center">
                  Saucey Paid <FaCrown />
                </div>
                <div className="text-sm">
                  (Admin option: Saucey is paying for delivery)
                </div>
              </div>
            }
            name="delivery_fee"
            checked={feeMode === "platform-absorbed"}
            onChange={(e) => {
              setFeeMode(
                e
                  ? "platform-absorbed"
                  : mileageBreakpoint.length > 0
                  ? "custom"
                  : "pass-through"
              );
            }}
          />
        )}
        {deliveryMethod === "dsp" && (
          <ToggleSwitch
            onLabel={
              <div>
                Pass through
                <div className="text-sm">
                  (Customer pays actual delivery cost, Saucey collects this
                  amount)
                </div>
              </div>
            }
            offLabel={
              <div>
                Pass through
                <div className="text-sm">
                  (Customer pays actual delivery cost, Saucey collects this
                  amount)
                </div>
              </div>
            }
            name="delivery_fee"
            checked={feeMode === "pass-through"}
            onChange={(e) => {
              setFeeMode(e ? "pass-through" : "custom");
            }}
          />
        )}
        {deliveryMethod === "employee" && (
          <>
            <ToggleSwitch
              onLabel={
                <div>
                  <div>
                    Fixed Rate{" "}
                    <input
                      type="number"
                      value={settings.amount}
                      className="form-input w-20"
                      onChange={(e) =>
                        setSettings({ ...settings, amount: e.target.value })
                      }
                    />
                  </div>
                  <div className="text-sm">
                    (Customer pays a fixed rate regardless of distance, Saucey
                    charges you $0.25)
                  </div>
                </div>
              }
              offLabel={
                <div>
                  Fixed Rate
                  <div className="text-sm">
                    (Customer pays a fixed rate regardless of distance, Saucey
                    charges you $0.25)
                  </div>
                </div>
              }
              name="delivery_fee"
              checked={feeMode === "fixed"}
              onChange={(e) => {
                setFeeMode(e ? "fixed" : "custom");
              }}
            />
          </>
        )}
        <ToggleSwitch
          onLabel={
            <div>
              {deliveryMethod === "dsp"
                ? "Custom Rate"
                : "Distance based delivery fee"}
              <div className="text-sm">
                {deliveryMethod === "dsp"
                  ? "(You set the custom delivery fee charged to the customer, Saucey collects ACTUAL delivery cost)"
                  : "(You set the custom delivery fee charged to the customer, Saucey charges you $0.25)"}
              </div>
            </div>
          }
          offLabel={
            <div>
              {deliveryMethod === "dsp"
                ? "Custom Rate"
                : "Distance based delivery fee"}
              <div className="text-sm">
                {deliveryMethod === "dsp"
                  ? "(You set the custom delivery fee charged to the customer, Saucey collects ACTUAL delivery cost)"
                  : "(You set the custom delivery fee charged to the customer, Saucey charges you $0.25)"}
              </div>
            </div>
          }
          name="delivery_fee"
          checked={feeMode === "custom"}
          onChange={(e) => {
            setFeeMode(e ? "custom" : "pass-through");
          }}
        />
      </div>
      {feeMode === "custom" && (
        <div className="w-full">
          Distance based delivery fee
          <MileageSlider
            setMileageBreakpoint={setMileageBreakpoint}
            initBreakpoints={mileageBreakpoint}
            largest={maxDeliveryDistance}
          />
          <div className="space-y-12">
            {sections.map((section, i) => (
              <div key={i} className="space-y-2">
                <div className="font-bold">
                  Apply these rules to deliveries between {section.start} to{" "}
                  {section.end} miles:
                </div>
                <div className="flex items-start flex-col gap-1">
                  {section.fees.map((fee, j) => (
                    <div key={j} className="flex gap-2">
                      <div className="flex items-center gap-2">
                        <div>For order subtotal over $</div>
                        <input
                          type="number"
                          value={fee.min}
                          className="form-input w-20"
                          onChange={(e) =>
                            handleFeeChange(i, j, e.target.value, "min")
                          }
                        />
                        , delivery fee is $
                      </div>
                      <div className="flex items-center gap-2">
                        <input
                          type="number"
                          value={fee.fee}
                          className="form-input w-20"
                          onChange={(e) =>
                            handleFeeChange(i, j, e.target.value, "fee")
                          }
                        />
                      </div>
                      {/* remove fee button */}
                      {section.fees.length > 1 && (
                        <DangerButton
                          onClick={(e) => {
                            e.preventDefault();
                            setSections((prevSections) => {
                              const newSections = [...prevSections];
                              newSections[i].fees = newSections[i].fees.filter(
                                (_, index) => index !== j
                              );
                              return newSections;
                            });
                          }}
                        >
                          <FaTrash />
                        </DangerButton>
                      )}
                      {j === section.fees.length - 1 && (
                        <SecondaryButton onClick={() => addFee(i)}>
                          <FaPlus />
                        </SecondaryButton>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DeliveryFee;
